import CrudResource from "@/components/CrudResource";
import { fmtDate } from "@/lib/api";

export default function Branches() {
  return (
    <CrudResource
      title="Kelola Cabang"
      subtitle="Daftar lokasi toko / cabang"
      endpoint="/branches"
      searchable={false}
      columns={[
        { key: "name", label: "Nama Cabang" },
        { key: "address", label: "Alamat" },
        { key: "phone", label: "Telepon" },
        { key: "created_at", label: "Dibuat", render: (r) => fmtDate(r.created_at) },
      ]}
      fields={[
        { name: "name", label: "Nama Cabang", required: true, full: true },
        { name: "address", label: "Alamat", full: true },
        { name: "phone", label: "Telepon" },
      ]}
    />
  );
}
